(function () {
  if (window.customElements.get('enhanced-footer')) return;

  class EnhancedFooter extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.startProofTicker();
      this.startCountdown();
      this.bindFlashForm();
    }

    /* ---- Proof ticker ---- */
    startProofTicker() {
      var track = this.querySelector('[data-ef-proof]');
      if (!track) return;
      var messages = track.querySelectorAll('.ef-proof-msg');
      if (messages.length < 2) return;
      var idx = 0;
      var interval = parseInt(this.dataset.proofInterval, 10) || 4000;
      setInterval(function () {
        messages[idx].classList.remove('is-active');
        idx = (idx + 1) % messages.length;
        messages[idx].classList.add('is-active');
      }, interval);
    }

    /* ---- Countdown ---- */
    startCountdown() {
      var cd = this.querySelector('[data-ef-countdown]');
      if (!cd) return;
      var mode = cd.dataset.mode || 'rolling';
      var hours = parseInt(cd.dataset.hours, 10) || 24;
      var fixedDate = cd.dataset.fixedDate;

      var deadline;
      if (mode === 'fixed' && fixedDate) {
        deadline = new Date(fixedDate).getTime();
      } else {
        var key = 'ef_countdown_deadline';
        var saved = null;
        try { saved = localStorage.getItem(key); } catch (e) {}
        if (saved && parseInt(saved, 10) > Date.now()) {
          deadline = parseInt(saved, 10);
        } else {
          deadline = Date.now() + (hours * 60 * 60 * 1000);
          try { localStorage.setItem(key, deadline); } catch (e) {}
        }
      }

      var hEl = cd.querySelector('[data-cd-h]');
      var mEl = cd.querySelector('[data-cd-m]');
      var sEl = cd.querySelector('[data-cd-s]');

      function pad(n) { return n < 10 ? '0' + n : '' + n; }

      function tick() {
        var diff = deadline - Date.now();
        if (diff <= 0) {
          if (hEl) hEl.textContent = '00';
          if (mEl) mEl.textContent = '00';
          if (sEl) sEl.textContent = '00';
          return;
        }
        var hrs = Math.floor(diff / (1000 * 60 * 60));
        var mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        var secs = Math.floor((diff % (1000 * 60)) / 1000);
        if (hEl) hEl.textContent = pad(hrs);
        if (mEl) mEl.textContent = pad(mins);
        if (sEl) sEl.textContent = pad(secs);
      }

      tick();
      setInterval(tick, 1000);
    }

    /* ---- Flash offer form ---- */
    bindFlashForm() {
      var form = this.querySelector('[data-ef-flash-form]');
      if (!form) return;
      var self = this;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var emailInput = form.querySelector('input[type=email]');
        if (!emailInput || !emailInput.value) return;
        try {
          var fd = new FormData();
          fd.append('form_type', 'customer');
          fd.append('utf8', '\u2713');
          fd.append('contact[email]', emailInput.value);
          fd.append('contact[tags]', 'footer-flash-offer,newsletter');
          fetch('/contact', { method: 'POST', body: fd });
        } catch (err) {}
        var successMsg = form.dataset.successMsg || 'Subscribed!';
        emailInput.value = '';
        var btn = form.querySelector('button');
        if (btn) {
          var orig = btn.textContent;
          btn.textContent = successMsg;
          btn.disabled = true;
          setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 3000);
        }
      });
    }
  }

  window.customElements.define('enhanced-footer', EnhancedFooter);
})();
